export default "__VITE_ASSET__CxIoc2OS__"